import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-overlay">
        <div className="hero-content">
          <h1>Your Safety, Our Priority</h1>
          <p>Shieldon Security Services provides professional, reliable protection for corporates, manufacturing units, research institutes, gated communities, business & Govt. establishments and event management companies.</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
